import React from 'react';
import { Bitcoin } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';

const AddressInput = ({ label, value, onChange, placeholder }) => (
  <div style={{ marginBottom: '16px' }}>
    <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
      {label}
    </label>
    <input
      type="text"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={{
        width: '100%',
        padding: '12px',
        backgroundColor: COLORS.background,
        border: `1px solid ${COLORS.border}`,
        borderRadius: '8px',
        color: COLORS.text,
        fontSize: '14px',
        fontFamily: 'monospace',
        boxSizing: 'border-box',
      }}
    />
  </div>
);

const CryptoAddressesSection = ({ settings, setSettings }) => {
  const updateAddress = (key, value) => {
    setSettings({ ...settings, [key]: value });
  };

  return (
    <div style={{
      backgroundColor: COLORS.card,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${COLORS.border}`,
      marginBottom: '16px',
    }}>
      <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '600', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Bitcoin size={20} color={COLORS.primary} />
        Крипто-адреса для депозитов
      </h3>
      
      <AddressInput
        label="USDT (TRC20 - Tron)"
        value={settings?.deposit_address_usdt_trc20}
        onChange={(v) => updateAddress('deposit_address_usdt_trc20', v)}
        placeholder="T..."
      />
      
      <AddressInput
        label="USDT (ERC20 - Ethereum)"
        value={settings?.deposit_address_usdt_erc20}
        onChange={(v) => updateAddress('deposit_address_usdt_erc20', v)}
        placeholder="0x..."
      />

      <AddressInput
        label="Bitcoin (BTC)"
        value={settings?.deposit_address_btc}
        onChange={(v) => updateAddress('deposit_address_btc', v)}
        placeholder="bc1..."
      />

      <div style={{ marginBottom: 0 }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Ethereum (ETH)</label>
        <input
          type="text"
          value={settings?.deposit_address_eth || ''}
          onChange={(e) => updateAddress('deposit_address_eth', e.target.value)}
          placeholder="0x..."
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
            fontFamily: 'monospace',
            boxSizing: 'border-box',
          }}
        />
      </div>
    </div>
  );
};

export default CryptoAddressesSection;
